import select2 from 'select2';
select2(window.jQuery);
/**
 * Initialized Select2 fields (topic multi-select)
 */
jQuery(function($) {
  $('[data-posts-index] select[name="posts-index_topic"]').select2();
});
